
















import { Component, Vue, Prop } from 'vue-property-decorator';
import { Button } from './components';
import IChildInfo from './types';

@Component({
  components: {
    Button,
  },
})
export default class ChildInfo extends Vue implements IChildInfo {
  @Prop({ type: String, default: '' })
  readonly name!: string;

  @Prop({ type: String, default: '' })
  readonly surname!: string;

  @Prop({ type: String, default: '' })
  readonly age!: string;

  @Prop({ type: Boolean, default: false })
  readonly showButton!: boolean;

  @Prop({ type: String, default: 'Изменить данные' })
  readonly editText!: string;

  @Prop({ type: Boolean, default: false })
  readonly isDisabled!: boolean;

  @Prop({ type: Number, default: 0 })
  readonly index!: number;

  public to: any = { name: 'profile-settings' };

  click(): void {
    this.$emit('click');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/blocks/children/sidebar/components/childrenlist/child/components/info/Info.vue